(function () {
  function activate(tab) {
    var root = tab.closest('[data-picker-tabs]');
    if (!root) return;

    var id = tab.getAttribute('data-picker-tab');
    var tabs = root.querySelectorAll('[data-picker-tab]');
    var panels = root.querySelectorAll('[data-picker-panel]');
    var i;

    for (i = 0; i < tabs.length; i++) {
      var isCurrent = tabs[i] === tab;
      tabs[i].classList.toggle('is-active', isCurrent);
      tabs[i].setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    }

    for (i = 0; i < panels.length; i++) {
      var match = panels[i].getAttribute('data-picker-panel') === id;
      panels[i].classList.toggle('is-active', match);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var tab = target.closest('[data-picker-tab]');
    if (!tab) return;

    event.preventDefault();
    activate(tab);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    var target = document.activeElement;
    if (!target || !target.closest) return;

    var tab = target.closest('[data-picker-tab]');
    if (!tab) return;

    var root = tab.closest('[data-picker-tabs]');
    if (!root) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-picker-tab]'));
    var index = tabs.indexOf(tab);
    var next = event.key === 'ArrowRight' ? index + 1 : index - 1;

    if (next < 0) next = tabs.length - 1;
    if (next >= tabs.length) next = 0;

    tabs[next].focus();
    activate(tabs[next]);
  });
})();
